import type { Language } from "@/stores/languageStore";

export function chooseLocalizedText(value: string, language: Language): string {
  const separator = " / ";
  if (!value.includes(separator)) return value;

  const [english, amharic] = value.split(separator);
  if (language === "am" && amharic?.trim()) return amharic.trim();
  return english?.trim() ?? value;
}
